<template>
  <div>
    <el-dialog title="淘宝商品拉取" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
      <div>
        <el-form :model="form" ref="form" label-width="100px">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="关键字" prop="Keyword" :rules="[
                { required: true, message: '请输入', trigger: 'blur' },
              ]">
                <el-input v-model="form.Keyword"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="seller" label="店铺名称"></el-table-column>
          <el-table-column prop="title" label="商品名称"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.pic_url" style="width: 100px;">
            </template>
          </el-table-column>
          <el-table-column prop="detail_url" label="商品地址" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="handleAddProduct(scope.row)">添加商品</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" @current-change="handleCurrentChange" :current-page="form.Page"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <span slot="footer">
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
} from "../../api/api";

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        Keyword: "",
        Page: 1,
        Type: 2,
      },
      tableData: [],
      total: 0,
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    init() {
      this.dialogVisible = true
    },
    handleQuery() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          KSAXApiRequest({
            path: 'Product_Spu/OneBoundListQuery',
            parms: '',
            parmsJson: this.form
          }).then((res) => {
            if (res.data.success) {
              if (res.data.response.error_code === "5000") {
                this.$message.error(res.data.response.error)
              } else {
                this.tableData = res.data.response.items.item;
                this.total = res.data.response.items.total_results;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleCurrentChange(value) {
      this.form.Page = value
      this.handleQuery()
    },
    handleAddProduct(row) {
      KSAXApiRequest({
        path: 'Product_Spu/OneBoundDetailQuery',
        parms: '',
        parmsJson: {
          Type: 2,
          num_iid: row.num_iid
        }
      }).then((res) => {
        if (res.data.success) {
          this.$emit("handlePull", res.data.response)
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped></style>
